import * as yup from 'yup'
import { CENTS_PATTERN, RATE_PATTERN } from 'src/constants/payment/constants'
import { PayoutType } from 'src/constants/payment/enums'

const RATE_MESSAGE = 'Enter 0 to 99.99 with at most two decimal places'
const CENTS_MESSAGE = 'Enter a whole number of cents'

/**
 * Rates are matched against a regex rather than checked numerically. `decimal(4,2)` bounds them
 * at 99.99 with two decimal places, and one pattern enforces both without the rounding error a
 * `value * 100` precision check introduces. The DTO has no `@Max`, so exceeding the bound fails
 * in the Postgres driver as an opaque 500 — this is the only place it is caught.
 */
/**
 * Blank is valid and means zero. A zero renders as an empty input with a `0` placeholder (see
 * `paymentInputs.ts`), so requiring these would make a customer whose fees are all zero — most
 * of them — load a form that is invalid before the admin touches it. `toNumber` maps the blank
 * back to `0` on save, so the wire value is unchanged either way.
 */
const rateSchema = yup
  .string()
  .matches(RATE_PATTERN, { message: RATE_MESSAGE, excludeEmptyString: true })
const centsSchema = yup
  .string()
  .matches(CENTS_PATTERN, { message: CENTS_MESSAGE, excludeEmptyString: true })

export const payoutSettingsValidator = yup.object({
  payoutType: yup
    .string()
    .required('Select a payout type')
    .oneOf(Object.values(PayoutType), 'Select a payout type'),
  payoutTimeInHours: yup.string().matches(CENTS_PATTERN, {
    message: 'Enter a whole number of hours',
    excludeEmptyString: true,
  }),
  buyerFee: centsSchema,
  buyerRate: rateSchema,
  loanTransferRate: rateSchema,
  loanTransferFee: centsSchema,
  wireTransferRate: rateSchema,
  wireTransferFee: centsSchema,
})
